import { connect } from 'react-redux';
import { openManaFiatGatewayRequest } from '../../../modules/gateway/actions';
import { openModal } from '../../../modules/modal/actions';
import RentalModal from './BuyManaWithFiatFeedbackModal';
const mapDispatch = (dispatch) => ({
    onTryAgain: (network, gateway) => dispatch(openManaFiatGatewayRequest(network, gateway)),
    onSelectOtherProvider: (selectedNetwork) => dispatch(openModal('BuyManaWithFiatModal', { selectedNetwork }))
});
export default connect(null, mapDispatch)(RentalModal);
//# sourceMappingURL=BuyManaWithFiatFeedbackModal.container.js.map